// Functie om de juiste titel te tonen op basis van de schermgrootte
const showCorrectTitle = () => {
    const isNotMobile = document.querySelector('.isNotMobile');
    const isMobile = document.querySelector('.isMobile');
    const isMobileView = window.innerWidth <= 767;

    if (isMobileView) {
        if (isNotMobile) {
            isNotMobile.remove();
        }
    } else {
        if (isMobile) {
            isMobile.remove();
        }
    }
}

// Roep de functie aan bij het laden van de pagina
window.addEventListener('load', showCorrectTitle);

// Herroep de functie bij het wijzigen van de grootte van het venster
window.addEventListener('resize', showCorrectTitle);